import React from "react";
import { motion } from "framer-motion";
import { Footprints, ScanEye, Coins, BadgeCheck } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { Section, SectionHead } from "@/components/landing/Section";

const ICONS = [Footprints, ScanEye, Coins];

export default function WhatIs() {
  const { t } = useLang();
  return (
    <Section id="about" testId="what-section" className="bg-paper/60 border-y border-line">
      <SectionHead kicker={t.what.kicker} title={t.what.title} />
      <div className="grid md:grid-cols-3 gap-6 md:gap-8 mt-14">
        {t.what.cols.map((c, i) => {
          const Icon = ICONS[i];
          return (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              data-testid={`what-col-${i}`}
              className="journal-card p-8"
            >
              <div className="flex items-center justify-between">
                <span className="w-12 h-12 rounded-full bg-moss/15 text-moss grid place-items-center">
                  <Icon className="w-6 h-6" />
                </span>
                <span className="font-display text-5xl text-line font-semibold">0{i + 1}</span>
              </div>
              <h3 className="font-display text-2xl font-semibold text-ink mt-6">{c.title}</h3>
              <p className="text-ink-muted leading-relaxed mt-3">{c.body}</p>
            </motion.div>
          );
        })}
      </div>
      <div data-testid="what-callout" className="mt-10 inline-flex items-center gap-3 rounded-full border-2 border-dashed border-moss/50 bg-parchment px-6 py-3.5 font-extrabold text-moss">
        <BadgeCheck className="w-5 h-5" /> {t.what.callout}
      </div>
    </Section>
  );
}
